import { useStore } from 'reactflow';

/** True when more than one board node is selected (rubber-band or Shift-click). */
export function useBoardMultiSelected(): boolean {
  return useStore((s) => s.getNodes().filter((n) => n.selected).length > 1);
}
